export enum LoanReviewStatus {
    InReview = 'InReview',
    Approved = 'Approved',
    Passed = 'Passed',
}

export const loanReviewStatusTitles: Record<LoanReviewStatus, string> = {
    [LoanReviewStatus.InReview]: 'In Review',
    [LoanReviewStatus.Approved]: 'Approved',
    [LoanReviewStatus.Passed]: 'Passed',
};
